"use client";

import { House, PencilRuler, Settings, Sparkles } from "lucide-react";

const ICON_MAP = {
  house: House,
  "pencil-ruler": PencilRuler,
  settings: Settings,
  sparkles: Sparkles,
};

export default function FeatureCard({ iconName, title, description }) {
  const Icon = iconName ? ICON_MAP[iconName] : null;

  return (
    <div className="flex gap-3">
      {Icon ? <Icon className="mt-1" /> : null}
      <div className=" space-y-3">
        <h3 className=" text-lg lg:text-2xl text-white  font-dana-light">{title}</h3>
        <div className="text-white-body text-sm lg:text-base">{description}</div>
      </div>
    </div>
  );
}
